<template>
    <x-page title="Jemaat (Duplikat)">
        <template #header-actions>
            <x-back-button :displayWarning="false" />
        </template>

        <x-table
            :headers="[
                '#',
                'ID',
                'Nama Lengkap',
                {
                    label: 'Usia',
                    visible: shouldDisplayAge,
                },
                'Email',
                'Status',
                'Alamat',
                'Jenis Kelamin',
                '',
            ]"
            :is-loading="isLoading"
        >
            <tr
                v-for="(resource, index) in resources"
                :key="resource.id"
                v-show="!isLoading"
            >
                <td>{{ rowIndex(index, $route.query) }}</td>
                <td class="nowrap">
                    <router-link
                        :to="`/admin/members/${resource.id}`"
                        title="Klik untuk lihat detail"
                    >
                        {{ resource.id }}
                    </router-link>
                </td>
                <td class="nowrap">
                    <router-link
                        :to="`/admin/members/${resource.id}`"
                        title="Klik untuk lihat detail"
                    >
                        {{ resource.name }}
                    </router-link>
                    <div v-if="Boolean(resource.user_account)">
                        <x-label
                            color="primary"
                            :title="`Tersambung dengan user account ${resource.user_account.email}`"
                        >
                            <i class="fa fa-user" />
                            {{ resource.user_account.name }}
                        </x-label>
                    </div>
                    <img
                        v-if="resource.image_thumb_url"
                        :src="resource.image_thumb_url"
                        class="img-responsive"
                        style="max-height: 100px; margin-top: 5px"
                    />
                </td>
                <td v-if="shouldDisplayAge">
                    {{ resource.age || "-" }}
                </td>
                <td class="nowrap">
                    {{ resource.email }}
                </td>
                <td class="nowrap">
                    {{ resource.status }}
                </td>
                <td class="nowrap">
                    <div v-html="$options.filters.nl2br(resource.address)" />
                </td>
                <td class="nowrap">
                    {{ resource.gender }}
                </td>
                <td>
                    <x-quick-action-button
                        :url="`/admin/members/${resource.id}/move-group`"
                        :disabled="isLoading"
                        v-if="can('updateMembers')"
                        title="Pindah Group"
                        icon="refresh"
                    />
                    <x-quick-edit-button
                        :url="`/admin/members/${resource.id}/edit`"
                        :disabled="isLoading"
                        v-if="can('updateMembers')"
                    />
                    <x-quick-delete-button
                        @click="deleteResource(resource)"
                        :disabled="isLoading"
                        v-if="can('deleteMembers')"
                    />
                    <x-quick-action-button
                        v-if="can('updateMembers') && isLatestDuplicate(resource)"
                        :icon="'compress'"
                        @click="showMergeModal(resource)"
                        :disabled="isLoading"
                        title="Merge duplikat"
                        color="warning"
                    />
                </td>
            </tr>
        </x-table>

        <x-pagination
            v-if="shouldRenderPagination"
            :pagination="meta"
            :query="$route.query"
            :disabled="isLoading"
        />

        <!-- Merge Comparison Modal -->
        <!-- Merge Comparison Modal -->
        <x-modal id="merge-compare-modal" title="Perbandingan Data Merge">
            <div v-if="mergeTarget">
                <div class="alert alert-warning">
                    <i class="fa fa-exclamation-triangle"></i>
                    Data dari <strong>sumber</strong> (akan dihapus) akan di-merge ke <strong>target</strong> (akan dipertahankan).
                    Journey, alamat, dan email akan digabungkan.
                </div>

                <div class="table-responsive">
                    <table class="table table-bordered table-striped">
                        <thead>
                            <tr>
                                <th style="width: 20%">Field</th>
                                <th class="success" style="width: 40%">
                                    <i class="fa fa-arrow-left"></i>
                                    Target (ID: {{ mergeTarget.id }})
                                    <span class="label label-success">Dipertahankan</span>
                                </th>
                                <th
                                    v-for="source in mergeSources"
                                    :key="'header-' + source.id"
                                    class="danger"
                                    :style="{ width: (40 / mergeSources.length) + '%' }"
                                >
                                    Sumber (ID: {{ source.id }})
                                    <span class="label label-danger">Akan dihapus</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td><strong>Nama</strong></td>
                                <td>{{ mergeTarget.name }}</td>
                                <td v-for="source in mergeSources" :key="'name-' + source.id">
                                    {{ source.name }}
                                </td>
                            </tr>
                            <tr>
                                <td><strong>Email</strong></td>
                                <td>{{ mergeTarget.email || '-' }}</td>
                                <td v-for="source in mergeSources" :key="'email-' + source.id">
                                    {{ source.email || '-' }}
                                </td>
                            </tr>
                            <tr>
                                <td><strong>Alamat</strong></td>
                                <td>{{ mergeTarget.address || '-' }}</td>
                                <td v-for="source in mergeSources" :key="'address-' + source.id">
                                    {{ source.address || '-' }}
                                </td>
                            </tr>
                            <tr v-for="field in mergeFields" :key="field.key" :class="{'warning': hasDifference(field.key)}">
                                <td>
                                    <strong>{{ field.label }}</strong>
                                    <div v-if="hasDifference(field.key)" class="small text-danger" style="margin-top: 4px"><i class="fa fa-hand-pointer-o"></i> Pilih salah satu</div>
                                </td>
                                <td>
                                    <label v-if="hasDifference(field.key)" style="font-weight: normal; cursor: pointer; display: block; margin: 0">
                                        <input type="radio" v-model="selectedOverrides[field.key]" :value="mergeTarget[field.key]">
                                        {{ mergeTarget[field.displayProp || field.key] || '-' }}
                                    </label>
                                    <span v-else>{{ mergeTarget[field.displayProp || field.key] || '-' }}</span>
                                </td>
                                <td v-for="source in mergeSources" :key="field.key + '-' + source.id">
                                    <label v-if="hasDifference(field.key)" style="font-weight: normal; cursor: pointer; display: block; margin: 0">
                                        <input type="radio" v-model="selectedOverrides[field.key]" :value="source[field.key]">
                                        {{ source[field.displayProp || field.key] || '-' }}
                                    </label>
                                    <span v-else>{{ source[field.displayProp || field.key] || '-' }}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="panel panel-info">
                    <div class="panel-heading">
                        <strong><i class="fa fa-info-circle"></i> Hasil Merge</strong>
                    </div>
                    <div class="panel-body">
                        <table class="table table-condensed" style="margin-bottom: 0">
                            <tr>
                                <td style="width: 20%"><strong>Email</strong></td>
                                <td>{{ mergedEmailPreview }}</td>
                            </tr>
                            <tr>
                                <td><strong>Alamat</strong></td>
                                <td>{{ mergedAddressPreview }}</td>
                            </tr>
                            <tr>
                                <td><strong>Journey</strong></td>
                                <td>Semua journey/milestone dari data sumber akan dipindahkan ke target</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>

            <template #footer>
                <x-close-modal-button />
                <button
                    type="button"
                    class="btn btn-warning"
                    :disabled="isLoading"
                    @click="confirmMerge"
                >
                    <i class="fa fa-compress"></i>
                    Merge Sekarang
                </button>
            </template>
        </x-modal>
    </x-page>
</template>

<script>
import XActionButton from "../../components/XActionButton.vue";
import XAjaxDropdown from "../../components/XAjaxDropdown.vue";
import XCheckboxWrapper from "../../components/XCheckboxWrapper.vue";
import XCloseModalButton from "../../components/XCloseModalButton.vue";
import XCreateButton from "../../components/XCreateButton.vue";
import XModal from "../../components/XModal.vue";
import XQuickDeleteButton from "../../components/XQuickDeleteButton.vue";
import XQuickEditButton from "../../components/XQuickEditButton.vue";
import XExcelExportButton from "../../components/XExcelExportButton.vue";
import XExcelImportButton from "../../components/XExcelImportButton.vue";
import XExcelImportModal from "../../components/XExcelImportModal.vue";
import XFilterBox from "../../components/XFilterBox.vue";
import XFormGroup from "../../components/XFormGroup.vue";
import XLabel from "../../components/XLabel.vue";
import XPage from "../../components/XPage.vue";
import XPagination from "../../components/XPagination.vue";
import XTable from "../../components/XTable.vue";
import {
    availableMemberStatuses,
    deletePrompt,
    handleGeneralXhrError,
} from "../../helpers";
import FilterableMixin from "../../mixins/FilterableMixin";
import PaginationMixin from "../../mixins/PaginationMixin";
import PermissionMixin from "../../mixins/PermissionMixin";
import XQuickActionButton from "../../components/XQuickActionButton.vue";
import XInputGroup from "../../components/XInputGroup.vue";
import XTableCount from "../../components/XTableCount.vue";
import XBackButton from "../../components/XBackButton.vue";

const defaultFilters = {
    age_min: null,
    age_max: null,
    group_category_id: null,
    group_role_id: null,
    search: null,
    status: null,
};

export default {
    beforeRouteUpdate(to, from, next) {
        this.fetchResources(to);
        next();
    },
    components: {
        XCloseModalButton,
        XCreateButton,
        XModal,
        XTable,
        XQuickEditButton,
        XQuickDeleteButton,
        XPage,
        XExcelExportButton,
        XExcelImportButton,
        XCheckboxWrapper,
        XFormGroup,
        XExcelImportModal,
        XFilterBox,
        XAjaxDropdown,
        XPagination,
        XLabel,
        XActionButton,
        XQuickActionButton,
        XInputGroup,
        XTableCount,
        XBackButton,
        XExcelImportButton,
    },
    computed: {
        availableStatuses() {
            return availableMemberStatuses();
        },
        shouldDisplayAge() {
            return true;
        },
        mergeFields() {
            return [
                { key: 'status', label: 'Status' },
                { key: 'gender', label: 'Jenis Kelamin' },
                { key: 'birthdate', label: 'Usia', displayProp: 'age' },
                { key: 'phone', label: 'Telepon' },
            ];
        },
        mergedEmailPreview() {
            if (!this.mergeTarget) return '-';
            const emails = [this.mergeTarget.email];
            this.mergeSources.forEach((s) => {
                if (s.email) emails.push(s.email);
            });
            return [...new Set(emails.filter(Boolean))].join(', ') || '-';
        },
        mergedAddressPreview() {
            if (!this.mergeTarget) return '-';
            const addresses = [this.mergeTarget.address];
            this.mergeSources.forEach((s) => {
                if (s.address) addresses.push(s.address);
            });
            return [...new Set(addresses.filter(Boolean))].join(', ') || '-';
        },
    },
    created() {
        const page = _.get(this.$route, "query.page", 1);
        this.preselectFilters(defaultFilters);
        this.handleFilter(page, true).catch(() => {
            this.fetchResources();
        });
    },
    data() {
        return {
            defaultGroupCategory: null,
            filters: { ...defaultFilters },
            isLoading: false,
            mergeTarget: null,
            mergeSources: [],
            selectedOverrides: {
                status: null,
                gender: null,
                birthdate: null,
                phone: null,
            },
            resources: [],
            selectedGroupCategory: null,
            selectedGroupRole: null,
            trashedCount: 0,
        };
    },
    methods: {
        deleteResource(resource) {
            deletePrompt({
                name: resource.name,
                onConfirm: () => {
                    this.isLoading = true;
                    const request = axios
                        .delete(`/api/members/${resource.id}`)
                        .then(() => {
                            this.$notify({
                                type: "success",
                                title: `Berhasil`,
                                text: `${resource.name} dihapus!`,
                            });
                            this.fetchResources();
                        });
                    handleGeneralXhrError(request).finally(() => {
                        this.isLoading = false;
                    });
                },
            });
        },
        getDuplicatesOf(resource) {
            return this.resources.filter(
                (r) => (r.name || "").toLowerCase() === (resource.name || "").toLowerCase() && r.id !== resource.id
            );
        },
        /**
         * Check if this resource is the latest (highest ID) among its name duplicates.
         */
        isLatestDuplicate(resource) {
            const duplicates = this.resources.filter(
                (r) => (r.name || "").toLowerCase() === (resource.name || "").toLowerCase()
            );
            if (duplicates.length <= 1) return false;
            const maxId = Math.max(...duplicates.map((r) => r.id));
            return resource.id === maxId;
        },
        /**
         * Check if a specific field differs between target and sources.
         */
        hasDifference(field) {
            if (!this.mergeTarget || !this.mergeSources || this.mergeSources.length === 0) return false;
            const targetValue = this.mergeTarget[field];
            return this.mergeSources.some((source) => source[field] !== targetValue);
        },
        /**
         * Open the comparison modal with target and source data.
         */
        showMergeModal(resource) {
            const duplicates = this.getDuplicatesOf(resource);

            if (duplicates.length === 0) {
                this.$notify({
                    type: "warn",
                    title: "Tidak ada duplikat",
                    text: "Tidak ditemukan data duplikat untuk di-merge.",
                });
                return;
            }

            this.mergeTarget = resource;
            this.mergeSources = duplicates;

            // Reset and initialize overrides to target's values by default
            this.selectedOverrides = {
                status: resource.status,
                gender: resource.gender,
                birthdate: resource.birthdate,
                phone: resource.phone,
            };

            $('#merge-compare-modal').modal('show');
        },
        /**
         * Confirm and execute the merge after reviewing the comparison.
         */
        confirmMerge() {
            if (!this.mergeTarget || this.mergeSources.length === 0) return;

            this.isLoading = true;
            const request = axios
                .post("/api/members/merge", {
                    target_id: this.mergeTarget.id,
                    source_ids: this.mergeSources.map((r) => r.id),
                    overrides: this.selectedOverrides,
                })
                .then(() => {
                    $('#merge-compare-modal').modal('hide');
                    this.$notify({
                        type: "success",
                        title: "Berhasil",
                        text: `Data berhasil di-merge ke ${this.mergeTarget.name}!`,
                    });
                    this.mergeTarget = null;
                    this.mergeSources = [];
                    this.fetchResources();
                });
            handleGeneralXhrError(request).finally(() => {
                this.isLoading = false;
            });
        },
        fetchResources(route = this.$route) {
            this.isLoading = true;
            const request = axios
                .get("/api/members", {
                    params: {
                        ...route.query,
                        duplicated: 1,
                        with: ["user_account"],
                        without_global_scopes: 1,
                        without_trashed: 1,
                    },
                })
                .then((response) => {
                    this.$set(this, "resources", response.data.data);
                    this.setMeta(response);
                });
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false;
            });
        },
        handleFilter(page = 1, replace = false) {
            const payload = {
                path: this.$route.path,
                query: _.pickBy({
                    ...this.filters,
                    page,
                }),
            };
            if (replace) return this.$router.replace(payload);
            return this.$router.push(payload);
        },
        resetFilter() {
            this.filters = { ...defaultFilters };
            this.handleFilter();
        },
    },
    mixins: [FilterableMixin, PaginationMixin, PermissionMixin],
    watch: {
        "filters.group_category_id": {
            handler(id) {
                this.syncFilterToProperty(
                    id,
                    "selectedGroupCategory",
                    `/api/group-categories/${id}`
                );
            },
            immediate: true,
        },
        "filters.group_role_id": {
            handler(id) {
                this.syncFilterToProperty(
                    id,
                    "selectedGroupRole",
                    `/api/group-roles/${id}`
                );
            },
            immediate: true,
        },
        selectedGroupCategory: {
            handler(resource) {
                this.syncPropertyToFilter(resource, "group_category_id");
            },
            deep: true,
        },
        selectedGroupRole: {
            handler(resource) {
                this.syncPropertyToFilter(resource, "group_role_id");
            },
            deep: true,
        },
    },
};
</script>